import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        display: ", ";\n        width: ", ";\n        height: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    flex-shrink: 0;\n    user-select: none;\n    line-height: inherit;\n    box-sizing: content-box;\n    ", "\n    ", "\n    ", "\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { marginAttributes } from '../../system/attributes/margin';
import { shouldForwardProp as _shouldForwardProp } from '../../utils';
import { colorAttributes } from '../../system/attributes/color';
var propertyList = {
  fontSize: true,
  display: true,
  small: true,
  medium: true,
  large: true,
  width: true,
  height: true,
  iconWidth: true,
  iconHeight: true
};

var getSizingStyles = function getSizingStyles(_ref) {
  var theme = _ref.theme,
      small = _ref.small,
      medium = _ref.medium,
      large = _ref.large,
      iconHeight = _ref.iconHeight,
      iconWidth = _ref.iconWidth,
      fontSize = _ref.fontSize;

  if (!theme) {
    return "\n            font-size: inherit;\n        ";
  }

  if (small) {
    return "\n            font-size: ".concat(theme.typography.pixelToRem(12), ";\n            padding: ").concat(theme.spacing(1.5), ";\n        ");
  }

  if (medium) {
    return "\n            font-size: ".concat(theme.typography.pixelToRem(16), ";\n            padding: ").concat(theme.spacing(1), ";\n        ");
  }

  if (large) {
    return "\n            font-size: ".concat(theme.typography.pixelToRem(24), ";\n        ");
  }

  return "\n        font-size: ".concat(typeof fontSize !== 'undefined' ? theme.typography.pixelToRem(fontSize) : 'inherit', ";\n    ");
};

export var SVGIconRoot = styled.svg.withConfig({
  shouldForwardProp: function shouldForwardProp(property) {
    return _shouldForwardProp(property, propertyList);
  }
})(_templateObject(), function (_ref2) {
  var iconWidth = _ref2.iconWidth,
      iconHeight = _ref2.iconHeight,
      display = _ref2.display;
  return css(_templateObject2(), display, iconWidth, iconHeight);
}, getSizingStyles, colorAttributes, marginAttributes);